export var AlarmSeverity;
(function (AlarmSeverity) {
    AlarmSeverity["Red"] = "red";
    AlarmSeverity["Orange"] = "orange";
    AlarmSeverity["Green"] = "green";
})(AlarmSeverity || (AlarmSeverity = {}));
export var AlarmType;
(function (AlarmType) {
    AlarmType["Panic"] = "panic";
    AlarmType["Assistance"] = "assistance";
    AlarmType["Test"] = "test";
    AlarmType["Outage"] = "outage";
    AlarmType["Fire"] = "fire";
    AlarmType["Medical"] = "medical";
    AlarmType["Mandown"] = "mandown";
    AlarmType["Other"] = "other";
})(AlarmType || (AlarmType = {}));
export var ResponseGroupType;
(function (ResponseGroupType) {
    ResponseGroupType["Nearby"] = "nearby";
    ResponseGroupType["ResponsePartners"] = "responsePartners";
    ResponseGroupType["Personal"] = "personal";
    ResponseGroupType["Zone"] = "zone";
    ResponseGroupType["Police"] = "police";
})(ResponseGroupType || (ResponseGroupType = {}));
